module.exports = __webpack_public_path__ + "img/D201410_5.1fc40a77.jpg";